import {ContentState} from '../../store';

export const initialContentState: ContentState = {
  init: false,
  form: {
    integration_id: '',
    form_inputs: {
      // custom app forms contains dynamic variables
    },
  },
  isPreview: false,
  tmpForm: {},
}
